// SPEC-VERSION-VISIBILITY-AND-UPDATE-V1 (D-456): 版の比較・採番・強制判定の純関数。
//   副作用なし=vitest で単体検証可能。fetch/SW/registration を触る処理は swRegistration.js 側。
//   ここは「どちらが新しいか」「これ未満は使わせないか」だけを決める。

// 'x.y.z' → [x, y, z]（数値3要素）。不正なら null。プレフィックス 'v' は許容。
export function parseVersion(v) {
  if (typeof v !== 'string') return null
  const m = v.trim().replace(/^v/i, '').match(/^(\d+)\.(\d+)\.(\d+)$/)
  if (!m) return null
  return [Number(m[1]), Number(m[2]), Number(m[3])]
}

// a<b→-1 / a==b→0 / a>b→1。どちらか不正なら null（呼び出し側で判断させる=強制側に倒さないため）。
export function compareVersions(a, b) {
  const pa = parseVersion(a)
  const pb = parseVersion(b)
  if (!pa || !pb) return null
  for (let i = 0; i < 3; i++) {
    if (pa[i] !== pb[i]) return pa[i] < pb[i] ? -1 : 1
  }
  return 0
}

// patch を 1 上げる。ITEM_1: 昇格時の自動採番に使う（scripts/bump-patch.mjs から呼ぶ）。
//   minor/major は触らない。不正入力は例外（採番スクリプトは黙って壊れるより落ちる方が安全）。
export function bumpPatch(v) {
  const p = parseVersion(v)
  if (!p) throw new Error(`bumpPatch: invalid version "${v}"`)
  return `${p[0]}.${p[1]}.${p[2] + 1}`
}

// ITEM_2: minimum_supported の既定＝現行 major の 0 番台（例 1.2.3 → 1.0.0）。
//   major を上げたときだけ境界が自動で新 major に上がる。不正入力は null。
export function minimumSupportedFor(v) {
  const p = parseVersion(v)
  if (!p) return null
  return `${p[0]}.0.0`
}

// ITEM_6: current が minimum 未満か。ロックアウト防止＝どちらかが不正/欠落なら false（強制しない）。
export function isBelowMinimum(current, minimum) {
  if (!current || !minimum) return false
  const cmp = compareVersions(current, minimum)
  if (cmp == null) return false // 比較不能（'dev' 等）は強制しない
  return cmp < 0
}
